import * as client from '../api/contentful-client';
import * as actions from '../actions/company';

export const fetchJobsHomePage = () => ({
  promise: () => client.getPage('jobs-home-page'),
  events: ['PROMISE_PENDING', actions.SET_JOBS_HOME_PAGE, 'PROMISE_ERROR'],
});

export const fetchJobs = () => ({
  promise: () => client.getJobs(),
  events: ['PROMISE_PENDING', actions.SET_JOBS, 'PROMISE_ERROR'],
});

export const fetchJobDescriptionPage = slug => ({
  promise: () => client.getJobDescriptionPage(slug),
  events: ['PROMISE_PENDING', actions.SET_JOB_DESCRIPTION_PAGE, 'PROMISE_ERROR'],
});

export const fetchJobDescriptionCallToAction = () => ({
  promise: () => client.getTextString('job-call-to-action'),
  events: ['PROMISE_PENDING', actions.SET_JOB_DESCRIPTION_CALL_TO_ACTION, 'PROMISE_ERROR'],
});



// WEBPACK FOOTER //
// ./app/api/company-api.js